export const MAXIMUM_CONTINUOUS_DRIVING_MINUTES = 270;
export const MAXIMUM_DAILY_DRIVING_TIME_MINUTES = 540;
export const MAXIMUM_DAILY_DRIVING_TIME_EXTENDED_MINUTES = 600;
export const MAXIMUM_WEEKLY_DRIVING_MINUTES = 56 * 60;
export const MAXIMUM_TWO_WEEKLY_DRIVING_MINUTES = 90 * 60;
export const MAX_NUMBER_OF_RESTING_EXCEED_PER_WEEK = 2;
export const MAX_NUMBER_OF_DAILY_REST_VIOLATIONS = 3;
